import { render, staticRenderFns } from "./ConversationReplyEditor.vue?vue&type=template&id=b4874ad8"
import script from "./ConversationReplyEditor.vue?vue&type=script&lang=js"
export * from "./ConversationReplyEditor.vue?vue&type=script&lang=js"
import style0 from "./ConversationReplyEditor.vue?vue&type=style&index=0&id=b4874ad8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports